/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import "./button.scss";

/* we cannot override those values if we want to :'( */
const variantClasses = {
  default: "bg-primary text-base font-semibold text-white py-4 shadow",
  outlined: "border-2 border-primary font-semibold text-primary py-4 shadow",
  "outlined-white":
    "border-2 border-white font-semibold text-white py-4 shadow",
  "outlined-gray": "border border-gray-400 py-4",
  gray: "bg-gray-300 py-4",
};

/* Note: not a very nice API, try to come up with something better */
const Button = ({
  className,
  variant,
  children,
  startIcon,
  endIcon,
  component: Component = "button",
  ...rest
}) => {
  const classes = classNames(
    "button flex items-center justify-center rounded-lg ",
    className,
    variantClasses[variant]
  );

  return (
    <Component className={classes} {...rest}>
      {startIcon && <div className="ltr:mr-3 rtl:ml-3">{startIcon}</div>}
      {children}
      {endIcon && <div className="ltr:ml-3 rtl:mr-3">{endIcon}</div>}
    </Component>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(["outlined", "default", "outlined-white", "gray"]),
  // color: PropTypes.oneOf(["primary", "secondary", "success", "error"]),
  children: PropTypes.element,
  startIcon: PropTypes.element,
  endIcon: PropTypes.element,
  component: PropTypes.node,
};

export default Button;
